import { randomLightColors } from './constants'
import { hash } from './helpers'

export const generateRandomLightColor = seed =>
  randomLightColors[hash(seed.toString()) % randomLightColors.length]
